export const toISO8601 = (date, resetHours?) => {
  date = new Date(date);

  if (resetHours) {
    date.setHours(0, 0, 0, 0);
  }

  const twoDigitDatePart = (number) => String(number).padStart(2, '0');

  const year = date.getFullYear();
  const month = twoDigitDatePart(date.getMonth() + 1);
  const day = twoDigitDatePart(date.getDate());
  const hours = twoDigitDatePart(date.getHours());
  const minutes = twoDigitDatePart(date.getMinutes());
  const seconds = twoDigitDatePart(date.getSeconds());

  const timezoneOffset = -date.getTimezoneOffset();
  const sign = timezoneOffset >= 0 ? '+' : '-';
  const offsetHours = twoDigitDatePart(Math.floor(Math.abs(timezoneOffset) / 60));
  const offsetMinutes = twoDigitDatePart(Math.abs(timezoneOffset) % 60);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
};
